import React, { useState } from "react";
import Pagination from "../../../components/Pagination/Pagination";
import {
  formatLabel,
} from "../../../components/Constants/Constants";
import AppLoader from "../../../components/AppLoader/appLoader";
import "./ReportedIssues.css";
import { useReportedIssues } from "../../../customHooks/ReportedIssues/ReportedIssues/useReportedIssues";
import { Button, Modal, OverlayTrigger, Tooltip } from "react-bootstrap";
import CopyIcon from "../../../components/CopyIcon/CopyIcon";
import { Info, Plus, Trash2 } from "lucide-react";
import { useNavigate } from "react-router-dom";
import UnAuthorized from "../../UnAuthorized/UnAuthorized";
import usePermission from "../../../utils/usePermission";

const ReportedIssues = () => {
  const [activeTab, setActiveTab] = useState("issues");
  const navigate = useNavigate();

  const {
    data,
    loading,
    filters,
    setFilters,
    filterOptions,
    totalCount,
    currentPage,
    setCurrentPage,
    itemsPerPage,
    setItemsPerPage,
    totalPages,
    isRaiseModalOpen,
    openRaiseModal,
    closeRaiseModal,
    raiseIssueFormData,
    setRaiseIssueFormData,
    handleRaiseIssueSubmit,
    isSubmitting,
    categoryMapping,
    analytics,

    subCategoryOptions,
    handleDomainChange,
    handleCategoryChange,
    isDomainPreFilled,
  } = useReportedIssues(activeTab);

   const canViewIssues = usePermission("ISSUE_LISTING_VIEW");
  const canViewIssueDetails = usePermission("ISSUE_DETAILS_VIEW");


  const columnInfo = {
    issueSource: "The entity that originally reported the issue.",
    resolution: "The final resolution proposed or accepted (e.g., REFUND).",
    expectedResponse:
      "The deadline for the *next action* or response from the counter-party.",
    expectedResolution:
      "The final deadline by which the issue is expected to be fully resolved.",
    lastAction:
      "The most recent action taken by any party in the issue timeline.",
  };

  const handleFormChange = (e) => {
    const { id, value } = e.target;
    setRaiseIssueFormData((prev) => ({ ...prev, [id]: value }));
  };

  // --- MODIFIED: NEW Handler just for the file input ---
  const handleFileChange = (e) => {
    if (e.target.files) {
      // e.target.files is a FileList, not an array.
      // We convert it to an array and store it in the 'images' state.
      setRaiseIssueFormData((prev) => ({
        ...prev,
        images: Array.from(e.target.files),
      }));
    }
  };

  // --- NEW: Handlers for dynamic refs array ---
  // (Add these if you haven't already from the previous answer)

  const handleRefChange = (index, field, value) => {
    const newRefs = [...raiseIssueFormData.refs];
    newRefs[index] = { ...newRefs[index], [field]: value };
    setRaiseIssueFormData((prev) => ({ ...prev, refs: newRefs }));
  };

  const addRefRow = () => {
    setRaiseIssueFormData((prev) => ({
      ...prev,
      refs: [...prev.refs, { ref_type: "", ref_id: "" }],
    }));
  };

  const removeRefRow = (index) => {
    if (raiseIssueFormData.refs.length <= 1) return;
    const newRefs = raiseIssueFormData.refs.filter((_, i) => i !== index);
    setRaiseIssueFormData((prev) => ({ ...prev, refs: newRefs }));
  };

  return (
    <>
      {canViewIssues ? (
    <div className="m-4">
      <>
        {/* --- Tabs --- */}
        <div className="d-flex justify-content-between align-items-center mb-3">
          {/* Left side: Tabs */}
          <div className="d-flex gap-3 mb-3">
            <button
              className={`btn ${
                activeTab === "issues"
                  ? "text-white fw-bold" // Active classes
                  : "border-0 border-bottom text-muted" // Inactive classes
              }`}
              style={
                activeTab === "issues"
                  ? { backgroundColor: "#38d3f1", border: "none" } // Active style
                  : {} // No style for inactive
              }
              onClick={() => setActiveTab("issues")}
            >
              Issues
            </button>
            <button
              className={`btn ${
                activeTab === "grievances"
                  ? "text-white fw-bold" // Active classes
                  : "border-0 border-bottom text-muted" // Inactive classes
              }`}
              style={
                activeTab === "grievances"
                  ? { backgroundColor: "#38d3f1", border: "none" } // Active style
                  : {} // No style for inactive
              }
              onClick={() => setActiveTab("grievances")}
            >
              Escalated To Grievances
            </button>
          </div>

          {/* Right side: Raise Issue */}
          <button
            className="btn btn-primary px-3 fw-medium"
            onClick={openRaiseModal}
          >
            + Raise Issue
          </button>
        </div>
        <p className="text-muted small mb-3">
          Manage all your reported issues from this dashboard. Track their
          status, search for specific items, and report a new issue at any time
          by clicking the '+ Raise Issue' button.
        </p>

        {analytics && Object.keys(analytics).length > 0 && (
          <div className="row mb-4">
            {" "}
            {/* Smaller gutter and margin */}
            <div className="col">
              <div className="p-2 bg-white shadow-sm rounded text-center">
                <h6 className="text-muted mb-0 small">Open Issues</h6>
                <h4 className="fw-bold text-warning mb-0">
                  {/* Assumed analytics.open, update if needed */}
                  {analytics.open || 0}
                </h4>
              </div>
            </div>
            <div className="col">
              {" "}
              {/* Use 'col' to auto-fit */}
              <div className="p-2 bg-white shadow-sm rounded text-center">
                <h6 className="text-muted mb-0 small">Processing</h6>{" "}
                {/* 'mb-0' and 'small' */}
                <h4 className="fw-bold text-primary mb-0">
                  {" "}
                  {/* 'h4' */}
                  {analytics.processing || 0}
                </h4>
              </div>
            </div>
            <div className="col">
              <div className="p-2 bg-white shadow-sm rounded text-center">
                <h6 className="text-muted mb-0 small">Resolved</h6>
                <h4 className="fw-bold text-success mb-0">
                  {analytics.resolved || 0}
                </h4>
              </div>
            </div>
            <div className="col">
              <div className="p-2 bg-white shadow-sm rounded text-center">
                <h6 className="text-muted mb-0 small">Escalated</h6>
                <h4 className="fw-bold text-danger mb-0">
                  {analytics.escalated || 0}
                </h4>
              </div>
            </div>
            <div className="col">
              <div className="p-2 bg-white shadow-sm rounded text-center">
                <h6 className="text-muted mb-0 small">Closed</h6>
                <h4 className="fw-bold text-secondary mb-0">
                  {" "}
                  {/* Fixed typo from before */}
                  {analytics.closed || 0}
                </h4>
              </div>
            </div>
          </div>
        )}

        <div className="filters-wrapper bg-white px-3 py-2 rounded shadow-sm">
          <div className="row gx-4 gy-3 align-items-end flex-wrap">
            {/* Search By */}
            <div className="col-auto">
              <label className="form-label mb-1">Search By</label>
              <div className="input-group" style={{ minWidth: "400px" }}>
                <select
                  className="form-select"
                  style={{ maxWidth: "180px" }}
                  value={filters.search_by}
                  onChange={(e) =>
                    setFilters((f) => ({
                      ...f,
                      search_by: e.target.value,
                      search_value: "",
                    }))
                  }
                >
                  <option value="">Select Field</option>
                  <option value="issueId">Issue ID</option>
                  <option value="transaction_id">Transaction ID</option>
                  <option value="complainant_name">Issue Source</option>
                </select>

                <input
                  type="text"
                  className="form-control"
                  style={{ fontSize: "12px", padding: "none" }}
                  placeholder={`Enter ${
                    filters.search_by
                      ? filters.search_by.replace("_", " ")
                      : "value"
                  }`}
                  value={filters.search_value}
                  onChange={(e) =>
                    setFilters((f) => ({ ...f, search_value: e.target.value }))
                  }
                  disabled={!filters.search_by}
                />
              </div>
            </div>

            {/* Status */}
            <div className="col-auto">
              <label className="form-label mb-1">Status</label>
              <select
                className="form-select"
                value={filters.status}
                onChange={(e) =>
                  setFilters((f) => ({ ...f, status: e.target.value }))
                }
              >
                <option value="">All</option>
                {filterOptions?.status?.map((s) => (
                  <option key={s} value={s}>
                    {s
                      .replace(/_/g, " ")
                      .replace(/\b\w/g, (c) => c.toUpperCase())}
                  </option>
                ))}
              </select>
            </div>

            {/* Issue Category */}
            <div className="col-auto">
              <label className="form-label mb-1">Issue Category</label>
              <select
                className="form-select"
                value={filters.issue_category}
                onChange={(e) =>
                  setFilters((f) => ({ ...f, issue_category: e.target.value }))
                }
              >
                <option value="">All</option>
                {filterOptions?.issue_category?.map((s) => (
                  <option key={s} value={s}>
                    {s
                      .replace(/_/g, " ")
                      .replace(/\b\w/g, (c) => c.toUpperCase())}
                  </option>
                ))}
              </select>
            </div>

            <div className="col-auto">
              <label className="form-label mb-1">Issue Domain</label>
              <select
                className="form-select"
                value={filters.issue_domain}
                onChange={(e) =>
                  setFilters((f) => ({ ...f, issue_domain: e.target.value }))
                }
              >
                <option value="">All</option>
                {/* Note: .issue_domain is an array of objects */}
                {filterOptions?.issue_domain?.map((s) => (
                  <option key={s.code} value={s.code}>
                    {s.name}
                  </option>
                ))}
              </select>
            </div>

            {/* Resolution Type */}
            <div className="col-auto">
              <label className="form-label mb-1">Resolution Type</label>
              <select
                className="form-select"
                value={filters.resolution_type}
                onChange={(e) =>
                  setFilters((f) => ({ ...f, resolution_type: e.target.value }))
                }
              >
                <option value="">All</option>
                {filterOptions?.resolution_type?.map((s) => (
                  <option key={s} value={s}>
                    {s
                      .replace(/_/g, " ")
                      .replace(/\b\w/g, (c) => c.toUpperCase())}
                  </option>
                ))}
              </select>
            </div>

            {/* SLA Breach */}
            <div className="col-auto">
              <label className="form-label mb-1">SLA Breach</label>
              <select
                className="form-select"
                value={filters.sla_breach}
                onChange={(e) =>
                  setFilters((f) => ({ ...f, sla_breach: e.target.value }))
                }
              >
                <option value="">All</option>
                {filterOptions?.sla_breach?.map((s) => (
                  <option key={s} value={s}>
                    {s
                      .replace(/_/g, " ")
                      .replace(/\b\w/g, (c) => c.toUpperCase())}
                  </option>
                ))}
              </select>
            </div>

            {/* Created From */}
            <div className="col-auto">
              <label className="form-label mb-1">Created From</label>
              <input
                type="date"
                className="form-control"
                style={{ fontSize: "12px", padding: "none" }}
                value={filters.created_from}
                onChange={(e) =>
                  setFilters((f) => ({ ...f, created_from: e.target.value }))
                }
              />
            </div>

            {/* Created To */}
            <div className="col-auto">
              <label className="form-label mb-1">Created To</label>
              <input
                type="date"
                className="form-control"
                style={{ fontSize: "12px", padding: "none" }}
                value={filters.created_to}
                onChange={(e) =>
                  setFilters((f) => ({ ...f, created_to: e.target.value }))
                }
              />
            </div>

            {/* Clear Filters Button */}
            <div className="col d-flex">
              <button
                type="button"
                className="btn btn-primary no-hover-btn"
                style={{ padding: "5px 8px" }}
                onClick={() =>
                  setFilters({
                    status: "",
                    issueId: "",
                    issue_category: "",
                    issue_level: "",
                    issue_domain: "",
                    resolution_type: "",
                    sla_breach: "",
                    created_from: "",
                    created_to: "",
                    search_by: "",
                    search_value: "",
                    sort_order: "desc",
                  })
                }
              >
                Clear Filters
              </button>
            </div>
          </div>
        </div>

        <>
          {loading ? (
            <AppLoader />
          ) : (
            <div className="table-responsive mt-4">
              <table className="table table-bordered table-hover align-middle text-center">
                <thead className="table-light">
                  <tr>
                    <th>Issue ID</th>
                    <th>Transaction ID</th>
                    <th>
                      Issue Source
                      <OverlayTrigger
                        placement="top"
                        overlay={<Tooltip>{columnInfo.issueSource}</Tooltip>}
                      >
                        <span style={{ marginLeft: "4px", cursor: "help" }}>
                          <Info size={14} className="text-muted" />
                        </span>
                      </OverlayTrigger>
                    </th>
                    <th>Issue Category</th>
                    <th>Issue Description</th>
                    <th>Status</th>
                    <th>
                      Resolution
                      <OverlayTrigger
                        placement="top"
                        overlay={<Tooltip>{columnInfo.resolution}</Tooltip>}
                      >
                        <span style={{ marginLeft: "4px", cursor: "help" }}>
                          <Info size={14} className="text-muted" />
                        </span>
                      </OverlayTrigger>
                    </th>
                    <th>
                      Expected Response
                      <OverlayTrigger
                        placement="top"
                        overlay={
                          <Tooltip>{columnInfo.expectedResponse}</Tooltip>
                        }
                      >
                        <span style={{ marginLeft: "4px", cursor: "help" }}>
                          <Info size={14} className="text-muted" />
                        </span>
                      </OverlayTrigger>
                    </th>
                    <th>
                      Expected Resolution
                      <OverlayTrigger
                        placement="top"
                        overlay={
                          <Tooltip>{columnInfo.expectedResolution}</Tooltip>
                        }
                      >
                        <span style={{ marginLeft: "4px", cursor: "help" }}>
                          <Info size={14} className="text-muted" />
                        </span>
                      </OverlayTrigger>
                    </th>
                    <th>
                      Last Action
                      <OverlayTrigger
                        placement="top"
                        overlay={<Tooltip>{columnInfo.lastAction}</Tooltip>}
                      >
                        <span style={{ marginLeft: "4px", cursor: "help" }}>
                          <Info size={14} className="text-muted" />
                        </span>
                      </OverlayTrigger>
                    </th>
                    <th
                      style={{ cursor: "pointer" }}
                      onClick={() =>
                        setFilters((f) => ({
                          ...f,
                          sort_order: f.sort_order === "asc" ? "desc" : "asc",
                        }))
                      }
                    >
                      Created At{" "}
                      {filters.sort_order === "asc" ? (
                        <span>&uarr;</span>
                      ) : (
                        <span>&darr;</span>
                      )}
                    </th>
                    <th
                      style={{ cursor: "pointer" }}
                      onClick={() =>
                        setFilters((f) => ({
                          ...f,
                          sort_order: f.sort_order === "asc" ? "desc" : "asc",
                        }))
                      }
                    >
                      Updated At{" "}
                      {filters.sort_order === "asc" ? (
                        <span>&uarr;</span>
                      ) : (
                        <span>&darr;</span>
                      )}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {data.length > 0 ? (
                    data.map((issue, i) => (
                      <tr key={i}>
                       <td>
                            <div className="copy-cell">
                              <OverlayTrigger
                                placement="top"
                                overlay={
                                  <Tooltip id={`tooltip-issue-${i}`}>
                                    {issue.issue_id}
                                  </Tooltip>
                                }
                              >
                                <button
                                  className="btn btn-link btn-sm p-0 truncate-cell"
                                  onClick={() => {
                                    if (canViewIssueDetails) {
                                      navigate(
                                        `/issues/seller/${issue.issue_id}`
                                      );
                                    } else {
                                      alert(
                                        "You do not have permission to view issue details."
                                      );
                                    }
                                  }}
                                  disabled={!canViewIssueDetails} // Disable clicking visually
                                  style={{
                                    cursor: canViewIssueDetails
                                      ? "pointer"
                                      : "not-allowed",
                                    opacity: canViewIssueDetails ? 1 : 0.5,
                                  }}
                                >
                                  {issue.issue_id}
                                </button>
                              </OverlayTrigger>

                              <CopyIcon textToCopy={issue.issue_id} />
                            </div>
                          </td>

                        {/* --- Transaction ID (MODIFIED) --- */}
                        <td>
                          <div className="copy-cell">
                            <OverlayTrigger
                              placement="top"
                              overlay={
                                <Tooltip id={`tooltip-tx-${i}`}>
                                  {issue.transaction_id}
                                </Tooltip>
                              }
                            >
                              <span className="truncate-cell">
                                {issue.transaction_id}
                              </span>
                            </OverlayTrigger>
                            <CopyIcon
                              textToCopy={issue.transaction_id}
                              className="copy-icon-top-right"
                            />
                          </div>
                        </td>

                        {/* --- Issue Source (MODIFIED) --- */}
                        <td>
                          <div className="copy-cell">
                            <OverlayTrigger
                              placement="top"
                              overlay={
                                <Tooltip id={`tooltip-source-${i}`}>
                                  {issue.complainant_name}
                                </Tooltip>
                              }
                            >
                              <span className="truncate-cell">
                                {issue.complainant_name}
                              </span>
                            </OverlayTrigger>
                            <CopyIcon
                              textToCopy={issue.complainant_name}
                              className="copy-icon-top-right"
                            />
                          </div>
                        </td>
                        <td>{issue.issue_category}</td>
                        <td>{issue.issue_description}</td>
                        <td>{issue.status}</td>
                        <td>{issue.resolution}</td>
                        <td>{issue.expected_response}</td>
                        <td>{issue.expected_resolution}</td>
                        <td>{formatLabel(issue.last_action)}</td>
                        <td>{issue.CreatedAt}</td>
                        <td>{issue.updated_at}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td
                        colSpan={12}
                        className="text-center py-4 text-gray-500"
                      >
                        No {activeTab} Found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          )}

          {/* --- Pagination --- */}
          {totalCount > 0 && (
            <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              startItem={(currentPage - 1) * itemsPerPage + 1}
              endItem={Math.min(currentPage * itemsPerPage, totalCount)}
              totalItems={totalCount}
              itemsPerPage={itemsPerPage}
              onItemsPerPageChange={setItemsPerPage}
              onPageChange={setCurrentPage}
            />
          )}
        </>
        <Modal
          show={isRaiseModalOpen}
          onHide={closeRaiseModal}
          centered
          size="lg"
        >
          <Modal.Header closeButton>
            <Modal.Title>Raise a New Issue</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <form>
              {/* --- Dropdowns --- */}
              <div className="row">
                <div className="col-md-4 mb-3">
                  <label htmlFor="domain" className="form-label">
                    Domain <span className="text-danger">*</span>
                  </label>
                  <select
                    id="domain"
                    className="form-select"
                    value={raiseIssueFormData.domain}
                    onChange={handleDomainChange}
                    disabled={isDomainPreFilled}
                  >
                    <option value="">Select Domain</option>
                    {filterOptions?.issue_domain?.map((d) => (
                      <option key={d.code} value={d.code}>
                        {d.name}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="col-md-4 mb-3">
                  <label htmlFor="issue_category" className="form-label">
                    Category <span className="text-danger">*</span>
                  </label>
                  <select
                    id="issue_category"
                    className="form-select"
                    value={raiseIssueFormData.issue_category}
                    onChange={handleCategoryChange}
                    disabled={!raiseIssueFormData.domain}
                  >
                    <option value="">Select Category</option>
                    {categoryMapping.map((c) => (
                      <option key={c.code} value={c.category}>
                        {c.category}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="col-md-4 mb-3">
                  <label htmlFor="issue_subcategory" className="form-label">
                    Subcategory <span className="text-danger">*</span>
                  </label>
                  <select
                    id="issue_subcategory"
                    className="form-select"
                    value={raiseIssueFormData.issue_subcategory}
                    onChange={handleFormChange}
                    disabled={!raiseIssueFormData.issue_category}
                  >
                    <option value="">Select Subcategory</option>
                    {subCategoryOptions.map((sc) => (
                      <option
                        key={sc.code}
                        value={sc.sub_category || sc.subb_category}
                      >
                        {sc.sub_category || sc.subb_category}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              {/* --- Inputs for BAP ID, BAP URI, and City --- */}
              <div className="row">
                <div className="col-md-8 mb-3">
                  <label htmlFor="bap_id" className="form-label">
                    BAP ID <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    id="bap_id"
                    className="form-control"
                    placeholder="e.g., igm-mock-service.ondc.org"
                    value={raiseIssueFormData.bap_id}
                    onChange={handleFormChange}
                  />
                </div>
                <div className="col-md-4 mb-3">
                  <label htmlFor="city" className="form-label">
                    City <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    id="city"
                    className="form-control"
                    placeholder="e.g., std:080"
                    value={raiseIssueFormData.city}
                    onChange={handleFormChange}
                  />
                </div>
              </div>
              <div className="mb-3">
                <label htmlFor="bap_uri" className="form-label">
                  BAP URI <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  id="bap_uri"
                  className="form-control"
                  placeholder="e.g., https://igm-mock-service.ondc.org"
                  value={raiseIssueFormData.bap_uri}
                  onChange={handleFormChange}
                />
              </div>
             

<hr />
<label className="form-label fw-bold">
  References <span className="text-danger">*</span>
</label>
{raiseIssueFormData.refs.map((ref, index) => (
  <div className="row" key={index}>
    <div className="col-md-5 mb-3">
      <label
        htmlFor={`ref_type_${index}`}
        className="form-label small"
      >
        Reference Type
      </label>
      
      {/* --- THIS IS THE MODIFIED BLOCK --- */}
      <select
        id={`ref_type_${index}`}
        className="form-select"
        value={ref.ref_type}
        onChange={(e) =>
          handleRefChange(index, "ref_type", e.target.value)
        }
      >
        <option value="">Select Type</option>
        {/* Map over the refs from filterOptions */}
        {filterOptions?.refs?.map((refType) => (
          <option key={refType} value={refType}>
            {/* Use your existing formatLabel function */}
            {formatLabel(refType)}
          </option>
        ))}
      </select>
      {/* --- END OF MODIFIED BLOCK --- */}

    </div>
    <div className="col-md-5 mb-3">
      <label
        htmlFor={`ref_id_${index}`}
        className="form-label small"
      >
        Reference ID
      </label>
      <input
        type="text"
        id={`ref_id_${index}`}
        className="form-control"
        placeholder="e.g., order-12345"
        value={ref.ref_id}
        onChange={(e) =>
          handleRefChange(index, "ref_id", e.target.value)
        }
      />
    </div>
    <div className="col-md-2 d-flex align-items-end mb-3">
      {raiseIssueFormData.refs.length > 1 && (
        <Button
          variant="outline-danger"
          size="sm"
          onClick={() => removeRefRow(index)}
        >
          <Trash2 size={16} />
        </Button>
      )}
    </div>
  </div>
))}
<Button variant="outline-primary" size="sm" onClick={addRefRow}>
  <Plus size={16} /> Add Another Reference
</Button>
<hr />

{/* ... rest of the modal form ... */}

              <div className="mb-3">
                <label htmlFor="short_desc" className="form-label">
                  Short Description <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  id="short_desc"
                  className="form-control"
                  required
                  placeholder="A brief summary of the issue"
                  value={raiseIssueFormData.short_desc}
                  onChange={handleFormChange}
                />
              </div>
              <div className="mb-3">
                <label htmlFor="detailed_desc" className="form-label">
                  Detailed Description
                </label>
                <textarea
                  id="detailed_desc"
                  className="form-control"
                  rows={4}
                  placeholder="Provide more details, steps to reproduce, etc."
                  value={raiseIssueFormData.detailed_desc}
                  onChange={handleFormChange}
                />
              </div>

              {/* --- File Input --- */}
              <div className="mb-3">
                <label htmlFor="image_file" className="form-label">
                  Images (Multi-select)
                </label>
                <input
                  type="file"
                  id="image_file"
                  className="form-control"
                  multiple
                  onChange={handleFileChange}
                />
              </div>
            </form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={closeRaiseModal}>
              Cancel
            </Button>
            <Button
              variant="primary"
              onClick={handleRaiseIssueSubmit}
              disabled={isSubmitting}
            >
              {isSubmitting ? "Raising..." : "Raise Issue"}
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    </div>
      ) : (
        <UnAuthorized />
      )}
    </>
  );
};

export default ReportedIssues;
